import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { PREWAGER_BONUS_TYPE } from '../../../../constants';
import { BonusProgressDetails } from '../../../BonusProgressDetails';

import styles from '../../index.module.css';

const BonusInfo = ({
  name = '',
  className = '',
  detailsList = '',
  id,
  isBonusDetailsLinkVisible,
  bonusType,
  status,
  cardType = 'freeSpins'
}) => {
  const { t } = useI18n();

  return (
    <Box direction="column" className={`${className} ${styles.info}`}>
      <AText
        color="po_txt_color_1"
        breed="BU"
        size="m"
        className={styles.title}
        data-testid="bonus-name"
      >
        {t(
          `content.bonus.template.name.${
            bonusType === PREWAGER_BONUS_TYPE ? 'bs.' : ''
          }${id}`,
          name
        )}
      </AText>
      <BonusProgressDetails
        detailsList={detailsList}
        className={styles.bonusDetails}
        status={status}
      />
      {isBonusDetailsLinkVisible && (
        <Box justify="start" align="center" className={styles.detailsLink}>
          <AText
            breed="R"
            size="s"
            color="accent_color_1"
            className={styles.bonusDetailsTxt}
          >
            {t(`bonuses.bonusCard.${cardType}.details`)}
          </AText>
          <Icon
            size="xs"
            name="icons/general/nav/go-to"
            color="accent_color_1"
          />
        </Box>
      )}
    </Box>
  );
};

export default BonusInfo;
